import { useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

/**
 * Relance manuelle d'un envoi AS400 en erreur : le batch le reprend à sa prochaine exécution.
 * retryTourLog renvoie true si la relance a été acceptée.
 */
export default function useRetryTourLog() {
  const [isLoading, setIsLoading] = useState(false);

  const retryTourLog = async (logId) => {
    try {
      setIsLoading(true);
      await fleetApi.post(`/tours/tours-logs/${logId}/retry`);
      toast.success(
        'Nouvel envoi planifié : les données repartent vers l’AS400 dans la minute.'
      );
      return true;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          'Le nouvel envoi n’a pas pu être demandé. Veuillez réessayer.'
      );
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, retryTourLog };
}
